import { ListItemIcon } from "@material-ui/core";
import { observer } from "mobx-react";
import React from "react";
import ListItemText from "@material-ui/core/ListItemText";
import { SecuredListItem } from "../Secured";

export interface SecuredListButtonProps {
  title: string;
  callbackFunction: (e: any) => void;
  children: React.ReactElement;
  disabled?: boolean;
}

@observer
export class SecuredListButton extends React.Component<
  SecuredListButtonProps,
  {}
> {
  public render() {
    return (
      <SecuredListItem
        key="export all"
        className="menuItem"
        onClick={this.props.callbackFunction}
        disabled={this.props.disabled}
      >
        <ListItemIcon>{this.props.children}</ListItemIcon>
        <ListItemText primary={this.props.title} />
      </SecuredListItem>
    );
  }
}
